import styled from 'styled-components';
export default styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1p90k69-0"
})(["display:flex;align-items:center;"]);